import Vue from 'vue';
import VueRouter from 'vue-router';

import guard from './guard';

// Layouts
import InicioLayout from '@/layout/Inicio';
import PrivadoLayout from '@/layout/Privado';
import PublicoLayout from '@/layout/Publico';

// Views
import CalculadoraView from '@/views/Calculadora';
import NotificacionesView from '@/views/Notificaciones';
import InicioSesionView from '@/views/InicioSesion';
import NoEncontradoView from '@/views/NoEncontrado';
import NoAccess from '@/views/AccesoRestringido';

import Reporte from '@/views/Reporte';
import GestionUsuarios from '@/views/GestionUsuarios';

import AdminContribuyente from '@/views/AdminContribuyente';
import MantenedorContribuyente from '@/views/MantenedorContribuyente';

import DispositivosOffline from '@/views/DispositivosOffline';

import SignIn from '@/views/SignIn';

import {controlRutas,fallbackRoutes} from './configRoutes';

Vue.use(VueRouter);

const routes = [
	{
		path: '/emitir',
		name: 'calculadora',
		component: PrivadoLayout,
		redirect: { name: 'calculadora-botonera'},
		children: [
			{
				path: '/',
				name: 'calculadora-botonera',
				component: CalculadoraView,
				meta: { permiso: true },
			},
			{
				path: '/reportes',
				name: 'Reportes',
				component: Reporte,
				meta: { permiso: 'reporte' },
			},
		],
	},
	{
		path: '/gestion-usuarios',
		name: 'GestionUsuariosLayout',
		component: PrivadoLayout,
		redirect: { name: 'GestionUsuarios'},
		children: [
			{
				path: '',
				name: 'GestionUsuarios',
				component: GestionUsuarios,
				meta: { permiso: 'usuarios' },
			}
		],
	},
	{
		path: '/admin-contribuyente',
		name: 'AdminContribuyenteLayout',
		component: PrivadoLayout,
		redirect: { name: 'AdminContribuyente'},
		children: [
			{
				path: '',
				name: 'AdminContribuyente',
				component: AdminContribuyente,
			}
		],
	},
	{
		path: '/contribuyente',
		name: 'MantenedorContribuyenteLayout',
		component: PrivadoLayout,
		redirect: { name: 'MantenedorContribuyente'},
		children: [
			{
				path: 'info',
				name: 'MantenedorContribuyente',
				component: MantenedorContribuyente,
			}
		],
	},
	{
		path: '/notificaciones',
		name: 'notificaciones',
		component: PrivadoLayout,
		redirect: { name: 'notificaciones-carga-masiva'},
		children: [
			{
				path: '/',
				name: 'notificaciones-carga-masiva',
				component: NotificacionesView,
				meta: { permiso: true },
			},
		],
	},
	{
		path: '/dispositivos-offline',
		name: 'DispositivosOfflineLayout',
		component: PrivadoLayout,
		redirect: { name: 'DispositivosOffline'},
		children: [
			{
				path: '',
				name: 'DispositivosOffline',
				component: DispositivosOffline,
				meta: { permiso: 'usuarios' },
			}
		],
	},
	{
		path: '/',
		name: 'inicio', // Usar esta ruta para ir a página inicial de login
		component: InicioLayout,
		redirect: { name: 'inicio-sesion'},
		meta: { requiresAuth: false },
		children: [
			{
				path: '/',
				name: 'inicio-sesion',
				component: InicioSesionView,
				meta: { requiresAuth: false },
			},
			{
				path: '/sign-in',
				name: 'SignIn',
				component: SignIn,
				meta: { requiresAuth: false },
			},
		],
	},
	{
		path: '*',
		component: PublicoLayout,
		redirect: { name: 'no-encontrado'},
		meta: { requiresAuth: false },
		children: [
			{
				path: '/',
				name: 'no-encontrado',
				component: NoEncontradoView,
			},{
				path: '/sin-permisos',
				name: 'NoAccess',
				component: NoAccess,
			}
		],
	},
];

const router = new VueRouter({
	mode: 'history',
	routes,
});
router.beforeEach(guard);

export default router;
